var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _g2, _path9, _g3, _path0, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 20,
    viewBox: "0 0 61 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4392 10.4612C26.4392 13.1623 24.3153 15.1573 21.7145 15.1573C19.1137 15.1573 16.9899 13.1623 16.9899 10.4612C16.9899 7.74481 19.1137 5.76508 21.7145 5.76508C24.3153 5.76508 26.4392 7.74481 26.4392 10.4612ZM24.3769 10.4612C24.3769 8.77309 23.1457 7.62199 21.7298 7.62199C20.3139 7.62199 19.0828 8.77309 19.0828 10.4612C19.0828 12.134 20.3139 13.3003 21.7298 13.3003C23.1457 13.3003 24.3769 12.134 24.3769 10.4612Z",
    fill: "#5F6368"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7164 10.4612C36.7164 13.1623 34.5926 15.1574 31.9915 15.1574C29.391 15.1574 27.2672 13.1623 27.2672 10.4612C27.2672 7.74481 29.391 5.76508 31.9915 5.76508C34.5926 5.76508 36.7164 7.74481 36.7164 10.4612ZM34.6385 10.4612C34.6385 8.77309 33.4072 7.62206 31.9915 7.62206C30.5758 7.62206 29.3445 8.77309 29.3445 10.4612C29.3445 12.1341 30.5758 13.3004 31.9915 13.3004C33.4072 13.3004 34.6385 12.1341 34.6385 10.4612Z",
    fill: "#5F6368"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5296 14.4821C46.5296 17.9505 44.4828 19.3778 42.0517 19.3778C39.7739 19.3778 38.4042 17.8431 37.881 16.6L39.6815 15.848C40.0048 16.6154 40.7894 17.5208 42.0517 17.5208C43.6058 17.5208 44.5597 16.554 44.5597 14.7583V14.0831H44.4828C44.0216 14.651 43.1286 15.1574 42.0052 15.1574C39.6505 15.1574 37.4962 13.1163 37.4962 10.4766C37.4962 7.82157 39.6505 5.76508 42.0052 5.76508C43.1286 5.76508 44.0216 6.25616 44.4828 6.8087H44.5597V6.04134H46.5296V14.4821ZM44.7137 10.4766C44.7137 8.81909 43.6058 7.60675 42.2056 7.60675C40.7739 7.60675 39.589 8.81909 39.589 10.4766C39.589 12.1187 40.7894 13.3004 42.2056 13.3004C43.6058 13.3004 44.7137 12.1187 44.7137 10.4766Z",
    fill: "#5F6368"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0915 1.07153V14.8684H48.0297V1.07153H50.0915Z",
    fill: "#5F6368"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1116 12.0114L59.7122 13.0857C59.1889 13.8531 57.9421 15.1729 55.7879 15.1729C53.1099 15.1729 51.125 13.1164 51.125 10.4767C51.125 7.68365 53.1409 5.78058 55.557 5.78058C58.0042 5.78058 59.1889 7.71434 59.5893 8.77324L59.8046 9.31034L53.5102 11.904C53.9874 12.8402 54.7409 13.3312 55.7879 13.3312C56.8343 13.3006 57.5729 12.7941 58.1116 12.0114ZM53.1719 10.3233L57.373 8.57372C57.1416 7.99055 56.4495 7.57621 55.6185 7.57621C54.572 7.57621 53.1099 8.51241 53.1719 10.3233Z",
    fill: "#5F6368"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7437_15700",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3471 0H0.844849V15.5022H16.3471V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7437_15700)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7437_15700",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 16,
    height: 16
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.061 6.34182H8.83841V9.33655H12.9958C12.6083 11.2391 10.9876 12.3313 8.83841 12.3313C6.30167 12.3313 4.25819 10.2879 4.25819 7.7511C4.25819 5.21439 6.30167 3.17091 8.83841 3.17091C9.93062 3.17091 10.9171 3.55846 11.6922 4.19265L13.9471 1.93778C12.573 0.739876 10.8114 0 8.83841 0C4.54005 0 1.08728 3.45277 1.08728 7.7511C1.08728 12.0494 4.54005 15.5022 8.83841 15.5022C12.7139 15.5022 16.2372 12.6837 16.2372 7.7511C16.2372 7.2931 16.1667 6.79984 16.061 6.34182Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7437_15700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.38147 12.3311V3.17078L6.37096 7.75094L0.38147 12.3311Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7437_15700",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 16,
    height: 16
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.061 6.34182H8.83841V9.33655H12.9958C12.6083 11.2391 10.9876 12.3313 8.83841 12.3313C6.30167 12.3313 4.25819 10.2879 4.25819 7.7511C4.25819 5.21439 6.30167 3.17091 8.83841 3.17091C9.93062 3.17091 10.9171 3.55846 11.6922 4.19265L13.9471 1.93778C12.573 0.739876 10.8114 0 8.83841 0C4.54005 0 1.08728 3.45277 1.08728 7.7511C1.08728 12.0494 4.54005 15.5022 8.83841 15.5022C12.7139 15.5022 16.2372 12.6837 16.2372 7.7511C16.2372 7.2931 16.1667 6.79984 16.061 6.34182Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7437_15700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.38147 3.17108L6.37096 7.75131L8.83725 5.60212L17.293 4.22806V-0.704468H0.38147V3.17108Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7437_15700",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 16,
    height: 16
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.061 6.34182H8.83841V9.33655H12.9958C12.6083 11.2391 10.9876 12.3313 8.83841 12.3313C6.30167 12.3313 4.25819 10.2879 4.25819 7.7511C4.25819 5.21439 6.30167 3.17091 8.83841 3.17091C9.93062 3.17091 10.9171 3.55846 11.6922 4.19265L13.9471 1.93778C12.573 0.739876 10.8114 0 8.83841 0C4.54005 0 1.08728 3.45277 1.08728 7.7511C1.08728 12.0494 4.54005 15.5022 8.83841 15.5022C12.7139 15.5022 16.2372 12.6837 16.2372 7.7511C16.2372 7.2931 16.1667 6.79984 16.061 6.34182Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7437_15700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.38147 12.3315L10.9512 4.22806L13.7346 4.58038L17.293 -0.704468V16.207H0.38147V12.3315Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_7437_15700",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 16,
    height: 16
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.061 6.34182H8.83841V9.33655H12.9958C12.6083 11.2391 10.9876 12.3313 8.83841 12.3313C6.30167 12.3313 4.25819 10.2879 4.25819 7.7511C4.25819 5.21439 6.30167 3.17091 8.83841 3.17091C9.93062 3.17091 10.9171 3.55846 11.6922 4.19265L13.9471 1.93778C12.573 0.739876 10.8114 0 8.83841 0C4.54005 0 1.08728 3.45277 1.08728 7.7511C1.08728 12.0494 4.54005 15.5022 8.83841 15.5022C12.7139 15.5022 16.2372 12.6837 16.2372 7.7511C16.2372 7.2931 16.1667 6.79984 16.061 6.34182Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_7437_15700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2952 16.2067L6.37316 7.75101L4.96387 6.694L17.2952 3.17078V16.2067Z",
    fill: "#4285F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.d1331891.svg";
export { ForwardRef as ReactComponent };